import React, { useEffect } from "react";
import { Form, Input, Button, Checkbox, Row } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { resetPassrequestApiFunction } from "./slice-login";

const ForgotPass = () => {
  const dispatch = useDispatch()
  const nav = useNavigate();
  const {resetrequestloading, data} = useSelector((state:any)=>state.login)
  
 
  const onFinish = (values: any) => {

    dispatch(resetPassrequestApiFunction(values.email))
  };

  return (
    <Row justify="center" align="middle" style={{minHeight: '100vh'}}>
    <Form
      name="forgot_password"
      className="login-form"
      initialValues={{
        
      }}
      onFinish={onFinish}
    >
      <Form.Item
        name="email"
        rules={[
          {
            required: true,
            message: "Please input your registered email!",
          },
        ]}
      >
        <Input
          prefix={<UserOutlined className="site-form-item-icon" />}
          placeholder="email"
        />
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit"  loading={resetrequestloading}>
          Reset Request
        </Button>
      </Form.Item>
    </Form>
    </Row>
  );
};

export {ForgotPass};